import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
}), 'NearMeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NearMeSharp.js
// module id = 5009
// module chunks = 2